import { render } from "./NewsPanel.vue?vue&type=template&id=02c91af6&scoped=true"
import script from "./NewsPanel.vue?vue&type=script&lang=js"
export * from "./NewsPanel.vue?vue&type=script&lang=js"

import "./NewsPanel.vue?vue&type=style&index=0&id=02c91af6&scoped=true&lang=scss"
import "./NewsPanel.vue?vue&type=style&index=1&id=02c91af6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c91af6"]])

export default __exports__